import { Container } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';
import { createContext, useRef } from 'react';
import ResetPracticeConversionModal from '../../../../../Modals/ResetPracticeConversionModal';
import EditConversionPimsModal from '../../../../../Modals/EditConversionPimsModal';
import hasPermission from '../../../../../Shared/hasPermission';
import Conversion from './Conversion';
import isEqual from 'react-fast-compare';

export const PermissionsContext = createContext({
    canManageConversionSteps: false,
    canManageConversions: false,
});

const ConversionStatus = () => {
    const { practiceId, practiceName } = useSelector(
        (state) => ({
            practiceId: state.practice.practice?.id,
            practiceName: state.practice.practice?.name,
        }),
        shallowEqual
    );
    const conversions = useSelector(
        (state) => state.practice.practice.conversions,
        isEqual
    );
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const can = (permission) => hasPermission(permission, permissions);
    const canManageConversionSteps = can('ManageConversionSteps');
    const canManageConversions = can('ManageConversions');
    const permissionObj = useRef({
        canManageConversionSteps,
        canManageConversions,
    });
    return (
        <PermissionsContext.Provider value={permissionObj.current}>
            <Container>
                {conversions?.map((c) => (
                    // TODO: we render all conversions if one changes, look at solutions
                    <div key={c.id} className="p-2 text-light">
                        <Conversion conversion={c} />
                    </div>
                ))}

                <EditConversionPimsModal
                    practiceName={practiceName}
                    practiceId={practiceId}
                />

                <ResetPracticeConversionModal />
            </Container>
        </PermissionsContext.Provider>
    );
};

export default ConversionStatus;
